import { Chip, Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { Allergen } from "../../../../../admin/products/productsTypes"

import { useWeekMenu } from "../../WeekMenuContext"

const useStyles = makeStyles()((theme) => ({
    option: {
        height: "1.5rem",
        cursor: "pointer",
    },
    // A picked chip wears the colors of the allergen tag it becomes on the dish.
    optionSelected: {
        background: theme.palette.tailwind.amber[200],
        color: theme.palette.tailwind.amber[800],
        borderColor: theme.palette.tailwind.amber[200],
    },
}))

type Props = Readonly<{
    selected: ReadonlyArray<Allergen>
    onToggle: (allergen: Allergen) => void
}>

/** Every known allergen as a toggle chip, highlighting the ones the dish carries. */
export function AllergenOptionChips({ selected, onToggle }: Props) {
    const { classes, cx } = useStyles()
    const { allergenOptions } = useWeekMenu()

    const isSelected = (allergen: Allergen) => selected.some((item) => item.id === allergen.id)

    return (
        <Stack direction="row" flexWrap="wrap" gap=".5rem">
            {allergenOptions.map((allergen) => (
                <Chip
                    key={allergen.id}
                    label={allergen.name}
                    size="small"
                    variant="outlined"
                    className={cx(classes.option, isSelected(allergen) && classes.optionSelected)}
                    onClick={() => onToggle(allergen)}
                />
            ))}
        </Stack>
    )
}
